module.exports = __webpack_public_path__ + "kr.svg?e590ec7a308ec34ecebaa872333e48a5";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/kr.svg
// module id = 1048
// module chunks = 27